// extracted by mini-css-extract-plugin
module.exports = {"option":"OptionSelect_option__1B274","desabilitar":"OptionSelect_desabilitar__3gwDC","focado":"OptionSelect_focado__iVuGP","novo":"OptionSelect_novo__mRLRP"};